import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // useNavigate 훅을 사용
import './css/LoginPage.css'; // CSS 파일 임포트

const LoginPage = () => {
    
     
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [qrCode, setQrCode] = useState('');
    const [secretKey, setSecretKey] = useState('');

    const [screen, setScreen] = useState(1); // 1: 첫 번째 화면, 2: 두 번째 화면, 3: 세 번째 화면


    const navigate = useNavigate(); // useNavigate 훅을 사용하여 navigate 함수 가져오기
    const handleLogin = async () => {
        const response = await axios.post('/setQR',null, {params:{user: username, password: password}});
        // setQrCode(`data:image/png;base64,${response.data}`);
        setSecretKey(response.data.secretKey);
        setQrCode(`data:image/png;base64,${response.data.qrCodeImage}`);

        // 화면 전환 로직
        if (response.data.qrCodeImage === '') {
            setScreen(1); // 첫 번째 화면
        } else if (response.data.qrCodeImage === 'Exist') {
            setScreen(2); // 두 번째 화면
        } else {
            setScreen(3); // 세 번째 화면
        }

 
    };

    const handleKeyDown = async (e) => {
        if (e.key === 'Enter') {
     
            const response = await axios.post('/setQR',null, {params:{user: username, password: password}});
        // setQrCode(`data:image/png;base64,${response.data}`);
        setSecretKey(response.data.secretKey);
        setQrCode(`data:image/png;base64,${response.data.qrCodeImage}`);

        // 화면 전환 로직
        if (response.data.qrCodeImage === '') {
            setScreen(1); // 첫 번째 화면
        } else if (response.data.qrCodeImage === 'Exist') {
            setScreen(2); // 두 번째 화면
        } else {
            setScreen(3); // 세 번째 화면
        }
          }
          

      };


      
    const handleKeyDown2 = async (e) => {
        if (e.key === 'Enter') {
     
            const response = await axios.post('/verify',null, { params:{user: username, code: verificationCode }});
            if (response.status === 200) {
                 
                // 인증 성공
                if(response.data=='인증완료')
                    {
                        navigate('/'); // 화면 전환
                    }
                else
                    {
                         alert("인증실패");
                    }
            } else {
                // 인증 실패
                console.log("인증실패");
            }
          }
          

      };

    const [verificationCode, setVerificationCode] = useState('');

    const handleVerify = async () => {
        const response = await axios.post('/verify',null, { params:{user: username, code: verificationCode }});
        if (response.status === 200) {
             
            // 인증 성공
            if(response.data=='인증완료')
                {
                    navigate('/'); // 화면 전환
                }
            else
                {
                     alert("인증실패");
                }
        } else {
            // 인증 실패
            console.log("인증실패");
        }
    };


    const handleFirstVerify = async (e) => {

        console.log('등록 할까');

       // if (e.key === 'Enter') {
             const response = await axios.post('/firstverify',null, { params:{user: username, code: verificationCode, key: secretKey, password: password }});
        if (response.status === 200) {
             console.log('등록 성공');
            // 인증 성공
            if(response.data=='등록완료')
                {
                    console.log('등록 완료');
                    navigate('/'); // 화면 전환
                }
            else
                {
                    console.log('등록 실패');
                     alert("등록실패");
                }
        } else {
            console.log('인증 실패');
            // 인증 실패
            console.log("등록실패");
        }
   // }
    };
    return (
        <div className='adminPage'>
            <h1>관리자 로그인</h1>
            {screen === 1 && 
            <div>
                <form   className="login-form">
                <div className="form-group">
                    <label htmlFor="empno">사번 : </label>
                    <input
                        type="text" placeholder="사번"  
                        value={username} onChange={(e) => setUsername(e.target.value)}
                        id="email"
                        
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">암호 : </label>
                    <input
                        type="password"
                        onKeyDown={handleKeyDown} // 여기다가 onKeyDown 이벤트 연결!
                        value={password} onChange={(e) => setPassword(e.target.value)} placeholder="암호"
                        required
                    />
                </div>
                <button type="button" className="login-button" onClick={handleLogin}>로그인</button>
               
                </form>
                 


                {/* <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="사용자명" />
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="비밀번호" />
                <button onClick={handleLogin}>로그인</button> */}
                
            </div>
            }
            {screen === 2 && 
            <div>
                <form   className="login-form"> 
                <div className="form-group">
                    <label htmlFor="empno">인증코드 : </label>
                    <input
                        onKeyDown={handleKeyDown2} // 여기다가 onKeyDown 이벤트 연결!
                        type="text" value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} placeholder="인증 코드"
                        
                        required
                    />
                </div>
                
                <button  type="button" className="login-button" onClick={handleVerify}>인증</button>
                </form>
            </div>
            }
            {screen === 3 &&
                <div>
                    <form   className="login-form"> 
                    <img src={qrCode}  />
                    <div className="form-group">
                    <label htmlFor="empno">변경할 비밀번호 : </label>
                    <input
                        type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="비밀번호"
                        
                        required
                    />
                    </div>
                    <div className="form-group">
                    <label htmlFor="empno">인증코드 : </label>
                    <input
                        type="text" value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} placeholder="인증 코드"
                        
                        required
                    />
                    </div>
                    <button  type="button" className="login-button"  onClick={handleFirstVerify}>등록</button>
                    </form>
                </div>
            }


            {/* {qrCode=='' ? (
                        <div>
                        <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="사용자명" />
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="비밀번호" />
                        <button onClick={handleLogin}>로그인</button>
                         
                        </div>
                        
                    ) : (
                        <div>
                        {secretKey=='Exist' ? (
                                                <div>
                                                    <input type="text" value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} placeholder="인증 코드" />
                                                    <button onClick={handleVerify}>인증</button>
                                                </div>
                                                
                                            ) : (
                                                <div>
                                                    <img src={qrCode}  />
                                                    <input type="text" value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} placeholder="인증 코드" />
                                                    <button onClick={handleFirstVerify}>등록</button>
                                                </div>
                                            )}
                         
                        </div>
                    )}
            */}
            
             
        </div>
    );
};

export default LoginPage;